module.exports = __webpack_public_path__ + "img/logo.60876e56.png";